import { Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import VideoComponent from '../../../components/VideoComponent';
import Button from '../../../components/Button';
import React, { ReactNode } from 'react';

export type VideoEmbedModalProps = React.PropsWithChildren<{
  showVideoEmbedModal: boolean;
  handleCloseVideoEmbedModal: () => void;
  stopVideo: () => void;
  videoLink?: string;
  embeddedNode?: ReactNode;
  title?: string;
}>;

const VideoEmbedModal = ({
  showVideoEmbedModal,
  handleCloseVideoEmbedModal,
  stopVideo,
  videoLink,
  embeddedNode,
  title,
}: VideoEmbedModalProps) => {
  const handleClose = () => {
    handleCloseVideoEmbedModal();
    stopVideo();
  };

  return (
    <Modal
      show={showVideoEmbedModal}
      onHide={handleClose}
      dialogClassName="modal-xl"
      className="custom-change-hsa-contributions-modal"
    >
      <ModalHeader closeButton className={'no-border'}>
        <h4 className="text-sm-20-lg-32">{title || 'HSA Overview Video'}</h4>
      </ModalHeader>
      <ModalBody>
        {videoLink && <VideoComponent embedLink={videoLink} />}
        {embeddedNode}
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleClose} variant={'primary-outline'}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default VideoEmbedModal;
